// extracted by mini-css-extract-plugin
export default {"message":"SsoCallback_message__xhoCE"};